import Alert from "@/stores/modules/AlertModule";
import Analytics from "@/stores/modules/AnalyticsModule";
import ConditionAnalyzer from "@/stores/modules/ConditionAnalyzerModule";
import MachineLog from "@/stores/modules/machineLog/MachineLogModule";
import Machine from "@/stores/modules/MachineModule";
import MachineSettings from "@/stores/modules/MachineSettingsModule";
import Maintenance from "@/stores/modules/MaintenanceModule";
import Organization from "@/stores/modules/OrganizationModule";
import Search from "@/stores/modules/SearchModule";
import StatusTimeline from "@/stores/modules/StatusTimelineModule";
import UserManagement from "@/stores/modules/UserManagementModule";
import User from "@/stores/modules/UserModule";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {}
});

store.registerModule("User", User);
store.registerModule("Maintenance", Maintenance);
store.registerModule("Organization", Organization);
store.registerModule("UserManagement", UserManagement);
store.registerModule("MachineSettings", MachineSettings);
store.registerModule("MachineLog", MachineLog);
store.registerModule("Alert", Alert);
store.registerModule("Search", Search);
store.registerModule("StatusTimeline", StatusTimeline);
store.registerModule("Analytics", Analytics);
store.registerModule("Machine", Machine);
store.registerModule("ConditionAnalyzer", ConditionAnalyzer);

export default store;
